import React from 'react';
import { connect } from 'react-redux';
import { getDateAndTime } from '../../utils/dateMethods';
import {
  Modal,
  NotificationManagementShowSave,
  Overlay,
  ToastBar,
} from '../../components';
import { PaymentManagementService } from '../../services';
import { getPaymentManagement } from '../../actions';
import {
  PaymentManagementFilter,
} from '../../forms';
import { exportToCSV, exportToExcel } from '../../utils/exportToExcel';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import avatcoin from '../../assets/svg/avatcoin.svg';
import avatcoinsilver from '../../assets/images/silvercoin.png';
import DataTable from '../Datatable';
import '../LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  payementmanagement: any;
  fetchNotificationList: any;
}

const PaymentManagement: React.FC<Props> = (props: Props) => {
  const {
    payementmanagement,
    fetchNotificationList,
  } = props;
  const { search } = useLocation();
  const { active } = queryString.parse(search);
  const navigate = useNavigate();
  const [filter, setFilter] = React.useState<any>({
    platform: '',
    startDate: '',
    endDate: '',
    userId: active || '',
    search: '',
    userType: '',
    page: 0,
    rowsPerPage: 10,
    isSortByCreatedAt: '',
    isPurchaseMadeFor: active ? true : '',
  });
  const [selected, setSelected] = React.useState<string[]>([]);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [showModal, setShowModal] = React.useState(false);
  const [showOverlay, setShowOverlay] = React.useState(false);
  const [showResend, setShowResend] = React.useState<any>({
    show: false,
    id: null,
    status: '',
  });
  const [loaderExport, setLoaderExport] = React.useState(false);
  const [notification, setNotification] = React.useState({
    show: false,
    message: '',
  });
  React.useEffect(() => {
    fetchNotificationList(filter);
  }, [fetchNotificationList, filter]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setFilter({ ...filter, page: newPage });
  };
  const count = payementmanagement.data.length !== 0 ? payementmanagement.data['Pagination-Count'] : 0;
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({ ...filter, page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  const handleSubmitFilter = (data: any) => {
    if (data.search !== ''
      || data.endDate !== null
      || data.startDate !== null
      || data.status !== '') {
      setFilter({
        ...filter,
        search: data.search,
        startDate: data.startDate ? data.startDate.utc() : '',
        endDate: data.endDate ? data.endDate.utc() : '',
        status: data.status,
        page: 0,
      });
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setShowResend({
      show: false,
      id: null,
      status: '',
    });
  };

  const handleStatus = (status: any) => {
    switch (status) {
      case 'Success':
        return 'Successful';
      case 'pending':
        return 'Pending';
      case 'refund':
        return 'Refunded';
      default:
        return '';
    }
  };

  function createData(data: any, index: number): any {
    const idS = data._id;
    const totalPrice = data.purchaseIn !== 'USD' ? (
      <div className="c_price">
        <img src={avatcoin} alt="avatcoin" />
        <span>{data.goldPrice}</span>
      </div>
    ) : `$${data.amount}`;
    return {
      sno: filter.page * filter.rowsPerPage + index + 1,
      id: idS,
      orderId: data.orderId.length > 10 ? (
        <div title={data.orderId}>
          {data.orderId.substring(0, 10)}
          ...
        </div>
      ) : data.orderId,
      transactionId: data?.transactionId ? data?.transactionId.length > 10 ? (
        <div title={data.transactionId}>
          {data.transactionId.substring(0, 10)}
          ...
        </div>
      ) : data?.transactionId : '',
      //      subscriptionId: data.subscriptionPlanId ? data.subscriptionPlanId : '__',
      username: data.sourceUser ? data.sourceUser.username : '',
      transactionDateAndTime: getDateAndTime(data.createdAt),
      purchasedItem: data.title.length > 50 ? (<div title={data.title}>{`${data.title.substring(0, 50)}...`}</div>) : data.title,
      itemType: data.itemType,
      totalPrice,
      discountedPrice: data.discountedPrice.gold !== 0 && data.discountedPrice.silver !== 0 ? (data.isViaDiscountPrice ? (data.discountedPrice ? (
        <div className="c_price">
          <img src={avatcoin} alt="avatcoin" />
          <span>{data.discountedPrice.gold}</span>
          <span className="separator">+</span>
          <img src={avatcoinsilver} alt="avatcoin" />
          <span>{data.discountedPrice.silver}</span>
        </div>
      ) : 0) : (
        <div className="c_price">
          <img src={avatcoin} alt="avatcoin" />
          <span>{data.discountedPrice.gold}</span>
          <span className="separator">+</span>
          <img src={avatcoinsilver} alt="avatcoin" />
          <span>{data.discountedPrice.silver}</span>
        </div>
      )) : '',
      amountpaid: data.isViaDiscountPrice ? (
        <div className="c_price">
          <img src={avatcoin} alt="avatcoin" />
          <span>{data.discountedPrice.gold}</span>
          <span className="separator">+</span>
          <img src={avatcoinsilver} alt="avatcoin" />
          <span>{data.discountedPrice.silver}</span>
        </div>
      ) : data.purchaseIn !== 'USD' ? (
        <div className="c_price">
          <img src={avatcoin} alt="avatcoin" />
          <span>{data.goldCoin}</span>
        </div>
      ) : `$${data.amount}`,
      transactionstatus: handleStatus(data.sourceUserPaymentStatus),
    };
  }

  const rows: any = [];

  if (payementmanagement.data.length !== 0 && payementmanagement.data) {
    payementmanagement.data.data.forEach((ele: any, index: number) => {
      rows.push(createData(ele, index));
    });
  }

  const headCells: any = [
    {
      id: 'sno', label: 'S.No', sort: false,
    },
    {
      id: 'orderId', label: 'Order ID', sort: false,
    },
    {
      id: 'transactionId', label: 'Transaction ID', sort: false,
    },
    {
      id: 'username', label: 'Username', sort: false,
    },
    {
      id: 'transactionDateAndTime', label: 'Transaction Date & Time', sort: true,
    },
    {
      id: 'purchasedItem', label: 'Purchased Item', sort: false,
    },
    {
      id: 'itemType', label: 'Item type', sort: false,
    },
    {
      id: 'totalPrice', label: 'Total Price', sort: false,
    },
    {
      id: 'discountedPrice', label: 'Discounted Price', sort: false,
    },
    {
      id: 'amountpaid', label: 'Amount paid', sort: false,
    },
    {
      id: 'transactionstatus', label: 'Transaction Status', sort: false,
    },
  ];

  const handleSort = (order: any, orderBy: any) => {
    if (orderBy === 'transactionDateAndTime') {
      setFilter({
        ...filter,
        page: 0,
        isSortByCreatedAt: order === 'asc' ? '1' : '-1',
      });
    }
  };
  const handleSelectedClick = (event: React.MouseEvent<unknown>, name: any) => {
    const selectedIndex = selected.indexOf(name.id);
    let newSelected: string[] = [];
    let newSelectedRows: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name.id);
      newSelectedRows = newSelectedRows.concat(selectedRows, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
      newSelectedRows = newSelectedRows.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1),
      );
    }
    setSelectedRows(newSelectedRows);
    setSelected(newSelected);
  };

  const handleClick = (event: any, name: any) => {
    if (event.target.localName === 'input') {
      handleSelectedClick(event, name);
    } else {
      navigate(`/paymentmanagement/paymentinfo/${name.id}`);
    }
  };

  const handleResetSorts = () => {
    setFilter({
      ...filter,
      startDate: '',
      endDate: '',
      search: '',
      page: 0,
      rowsPerPage: 10,
      isSortByCreatedAt: '',
      status: '',
    });
  };

  const handleExport = (exportType: string) => {
    setLoaderExport(true);
    if (exportType === 'XLSX') {
      if (selectedRows.length > 0) {
        const selectedRowDataModified: any = [];
        selectedRows.forEach((ele: any) => {
          const silver = ele.amountpaid.props?.children[4] ? `+ Silver(${ele.amountpaid.props.children[4].props.children})` : '';
          selectedRowDataModified.push({
            sno: ele.sno,
            orderId: ele.orderId?.props.title,
            transactionId: ele.transactionId?.props.title,
            username: ele.username,
            transactionDateAndTime: ele.transactionDateAndTime,
            purchasedItem: ele.purchasedItem,
            itemType: ele.itemType,
            totalPrice: ele.totalPrice?.props ? `Gold (${ele.totalPrice.props.children[1].props.children})` : ele.totalPrice,
            discountedPrice: ele.discountedPrice !== '' ? `Gold(${ele.discountedPrice.props.children[1].props.children}) + Silver(${ele.discountedPrice.props.children[4].props.children})` : '',
            amountpaid: ele.amountpaid?.props ? `Gold(${ele.amountpaid.props.children[1].props.children}) ${silver}` : ele.amountpaid,
            transactionstatus: ele.transactionstatus,
          });
        });
        exportToExcel(selectedRowDataModified, 'PaymentManagementData');
        setLoaderExport(false);
        setNotification({
          ...notification,
          show: true,
          message: 'Excel successfully downloaded.',
        });
      } else {
        PaymentManagementService.export({ ...filter, type: 'xlsx' }).then(() => {
          setLoaderExport(false);
          setNotification({
            ...notification,
            show: true,
            message: 'Excel has been sent on mail.',
          });
        }).catch((err: any) => {
          setLoaderExport(false);
          setNotification({
            show: true,
            message: err.response.data.message,
          });
        });
      }
    } else if (exportType === 'CSV') {
      if (selectedRows.length > 0) {
        const selectedRowDataModified: any = [];
        selectedRows.forEach((ele: any) => {
          selectedRowDataModified.push({
            sno: ele.sno,
            orderId: ele.orderId?.props.title,
            transactionId: ele.transactionId?.props.title,
            username: ele.username,
            transactionDateAndTime: ele.transactionDateAndTime,
            purchasedItem: ele.purchasedItem,
            itemType: ele.itemType,
            totalPrice: ele.totalPrice?.props ? `Gold(${ele.totalPrice.props.children[1].props.children})` : ele.totalPrice,
            discountedPrice: ele.discountedPrice !== '' ? `Gold(${ele.discountedPrice.props.children[1].props.children}) + Silver(${ele.discountedPrice.props.children[4].props.children})` : '',
            amountpaid: ele.amountpaid?.props ? `Gold(${ele.amountpaid.props.children[1].props.children}) + Silver(${ele.amountpaid.props.children[4].props.children})` : ele.amountpaid,
            transactionstatus: ele.transactionstatus,
          });
        });
        exportToCSV(selectedRowDataModified, 'PaymentManagementData');
        setLoaderExport(false);
        setNotification({
          ...notification,
          show: true,
          message: 'CSV successfully downloaded.',
        });
      } else {
        PaymentManagementService.export({ ...filter, type: 'csv' }).then(() => {
          setLoaderExport(false);
          setNotification({
            ...notification,
            show: true,
            message: 'CSV has been sent on mail.',
          });
        }).catch((err: any) => {
          setLoaderExport(false);
          setNotification({
            show: true,
            message: err.response.data.message,
          });
        });
      }
    }
  };

  return (
    <>
      {showOverlay && <Overlay />}
      <Modal
        id="block-user"
        isOpen={showModal}
        onClose={handleModalClose}
        onManageDisableScrolling={() => null}
        lightCloseButton={false}
      >
        {
          showResend.show && (
            <NotificationManagementShowSave
              handleModalClose={handleModalClose}
              id={showResend.id}
              fetchAdminList={() => setFilter({ page: 0 })}
              setShowOverlay={setShowOverlay}
              status={showResend.status}
            />
          )
        }
      </Modal>
      {
        notification.show && (
          <ToastBar
            message={notification.message}
            handleCloseMethod={() => setNotification({
              ...notification,
              show: false,
              message: '',
            })}
          />
        )
      }
      <div>
        <PaymentManagementFilter
          handleResetSorts={handleResetSorts}
          handleFormSubmit={handleSubmitFilter}
          handleExport={handleExport}
          loaderExport={loaderExport}
        />
        <div className="dataTableCover">
          <DataTable
            headCells_={headCells}
            rows_={rows}
            rowClick={handleClick}
            selected={selected}
            setSelected={setSelected}
            setSelectedRows={setSelectedRows}
            page={filter.page}
            rowsPerPage={filter.rowsPerPage}
            loading={payementmanagement.loadingInProgress}
            handleChangePage={handleChangePage}
            handleSort={handleSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            count={count}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  payementmanagement: state.payementmanagement,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchNotificationList: (payload: any) => dispatch(getPaymentManagement(payload)),
});

const PaymentManagementComponent = compose<React.ElementType>(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(PaymentManagement);

export default PaymentManagementComponent;
